module.exports = __webpack_public_path__ + "static/media/vitalPointsHome.e5778609.png";